import React from 'react';

const FeaturedLoader = () => {
  return (
    <section className='featuredLoader'>
      <div className='featuredLoader__container'>
        <div className='featuredLoader__item'>
          <div className='box loader-05'>
            <div className='loader-05' />
          </div>
        </div>

        <div className='featuredLoader__item'>
          <div className='box loader-05'>
            <div className='loader-05' />
          </div>
        </div>

        <div className='featuredLoader__item'>
          <div className='box loader-05'>
            <div className='loader-05' />
          </div>
        </div>

        <div className='featuredLoader__item'>
          <div className='box loader-05'>
            <div className='loader-05' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedLoader;
